import { defineStore } from 'pinia'
import i18n from '../i18n'

export const useInternationalStore = defineStore('international', {
  state: () => ({
    location: {
      abb: import.meta.env.VITE_I18N_ABB,
      code: Number(import.meta.env.VITE_I18N_CODE),
      region: import.meta.env.VITE_I18N_REGION,
      regionCn: import.meta.env.VITE_I18N_REGIONCN,
      icon: import.meta.env.VITE_I18N_ICON
    },
    select: [
      // { abb: 'en', code: -1, region: i18n.global.t('Header.site.global'), regionCn: 'Global', icon: 'Global' }, /** Global */
      { abb: 'en', code: 1, region: i18n.global.t('Header.site.us'), regionCn: 'United States', icon: '' },
      { abb: 'jp', code: 81, region: i18n.global.t('Header.site.ja'), regionCn: 'Japan', icon: 'japan' },
      { abb: 'ar', code: 9999, region: i18n.global.t('Header.site.minEast'), regionCn: 'Mid-East', icon: '' }
    ]
  }),
  actions: {}
})
